const HamburgerIcon = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="hamburger-icon"
  >
    <path
      d="M20 18H13M20 6H4H20ZM20 12H4H20Z"
      stroke="#314259"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { HamburgerIcon };
